"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePhoneNumber = exports.getDeliveryAddresses = exports.updateDeliveryAddress = exports.addDeliveryAddress = exports.createAccount = exports.getProfile = exports.sendPasswordResetEmail = exports.updateEmail = exports.getEmailExists = exports.getPreferencesNewsletter = exports.getCountries = exports.getGenders = exports.getTitles = exports.getLanguages = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    languages: {
        server: 'masterdata/language/all',
        client: 'api/aem/general/language/all',
    },
    titles: {
        server: 'masterdata/title/all',
        client: 'api/aem/general/title/all',
    },
    genders: {
        server: 'masterdata/gender/all',
        client: 'api/aem/general/gender/all',
    },
    countries: {
        server: 'masterdata/country/all',
        client: 'api/aem/general/country/available',
    },
    preferencesNewsletter: {
        client: 'api/customer/preference/newsletter',
    },
    emailExists: {
        client: 'api/customer/exists',
    },
    updateEmail: {
        client: 'api/customer/profile/update/email',
    },
    sendPasswordResetEmail: {
        client: 'api/credentials/forgot',
    },
    profile: {
        client: 'api/customer/profile/details',
    },
    createAccount: {
        client: 'api/customer/profile/create',
    },
    addDeliveryAddress: {
        client: 'api/customer/deliveryaddress/add',
    },
    updateDeliveryAddress: {
        client: 'api/customer/deliveryaddress/updateaddress',
    },
    getDeliveryAddresses: {
        client: 'api/customer/deliveryaddress',
    },
    updatePhoneNumber: {
        client: 'api/customer/profile/update/mobilephone',
    },
};
const processTitleData = (data, lang) => {
    const titles = [];
    data.forEach(title => {
        if (title.titleNameTranslations) {
            const customerTitle = {
                id: title.idTitle,
                title: title.titleNameTranslations[lang.toUpperCase()],
                sortOrder: title.sortOrder,
                idGender: title.idGender,
            };
            titles.push(customerTitle);
        }
    });
    return titles;
};
const processGenderData = (data, lang) => {
    const genders = [];
    data.forEach(function (gender) {
        if (gender.genderTitleTranslations) {
            const customerGender = {
                id: gender.idGenderPeople,
                peopleCode: gender.genderPeopleCode,
                gender: gender.genderTitleTranslations[lang.toUpperCase()],
            };
            genders.push(customerGender);
        }
    });
    return genders;
};
const getLanguages = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.languages, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getLanguages = getLanguages;
const getTitles = (_b, _c) => tslib_1.__awaiter(void 0, [_b, _c], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { lang }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.titles, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return processTitleData(result.data, lang);
});
exports.getTitles = getTitles;
const getGenders = (_d, _e) => tslib_1.__awaiter(void 0, [_d, _e], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { lang }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.genders, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return processGenderData(result.data, lang);
});
exports.getGenders = getGenders;
const getCountries = (_f) => tslib_1.__awaiter(void 0, [_f], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.countries, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getCountries = getCountries;
const getPreferencesNewsletter = (_g, _h) => tslib_1.__awaiter(void 0, [_g, _h], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { customerUUID }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.preferencesNewsletter, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        withCredentials: true,
        params: Object.assign(Object.assign({}, defaultRequestParams), { customerUUID }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getPreferencesNewsletter = getPreferencesNewsletter;
const getEmailExists = (_j, _k) => tslib_1.__awaiter(void 0, [_j, _k], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { email, sendEmail = false }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.emailExists, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        withCredentials: true,
        params: Object.assign(Object.assign({}, defaultRequestParams), { email,
            sendEmail }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getEmailExists = getEmailExists;
const updateEmail = (_l, _m) => tslib_1.__awaiter(void 0, [_l, _m], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { email, customerUUID }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.updateEmail, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
        params: Object.assign(Object.assign({}, defaultRequestParams), { email,
            customerUUID }),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.updateEmail = updateEmail;
const sendPasswordResetEmail = (_o, _p) => tslib_1.__awaiter(void 0, [_o, _p], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { email }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.sendPasswordResetEmail, isServer);
    const axiosConfig = {
        method: 'POST',
        headers: {
            'Content-Type': 'text/plain',
        },
        url,
        withCredentials: true,
        params: defaultRequestParams,
        data: email,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.sendPasswordResetEmail = sendPasswordResetEmail;
const getProfile = (_q) => tslib_1.__awaiter(void 0, [_q], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.profile, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        withCredentials: true,
        params: defaultRequestParams,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getProfile = getProfile;
const createAccount = (_r, _s) => tslib_1.__awaiter(void 0, [_r, _s], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { customerData }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.createAccount, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        data: customerData,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.createAccount = createAccount;
const addDeliveryAddress = (_t, address_1) => tslib_1.__awaiter(void 0, [_t, address_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, address) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.addDeliveryAddress, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        data: address,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.addDeliveryAddress = addDeliveryAddress;
const updateDeliveryAddress = (_u, address_2) => tslib_1.__awaiter(void 0, [_u, address_2], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, address) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.updateDeliveryAddress, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        data: address,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.updateDeliveryAddress = updateDeliveryAddress;
const getDeliveryAddresses = (_v) => tslib_1.__awaiter(void 0, [_v], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.getDeliveryAddresses, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getDeliveryAddresses = getDeliveryAddresses;
const updatePhoneNumber = (_w, phoneNumber_1) => tslib_1.__awaiter(void 0, [_w, phoneNumber_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, phoneNumber) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, urlMapping.updatePhoneNumber, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        headers: { 'Content-Type': 'text/plain' },
        withCredentials: true,
        params: { mainWebshop: defaultRequestParams.mainWebshop },
        data: phoneNumber,
    };
    return yield axios_1.default.request(axiosConfig);
});
exports.updatePhoneNumber = updatePhoneNumber;
//# sourceMappingURL=customer.api.js.map